module.exports = __webpack_public_path__ + "static/img/login_logo.04e1086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login_logo.png
// module id = Jl7H
// module chunks = 1